import { OuterContentContainer } from "@themes/pollinator/ui/OuterContentContainer";
import { AppPageHeader } from "@themes/pollinator/ui/AppPageHeader";
import { SectionHeading } from "@themes/pollinator/ui/SectionHeading";
import {
  AccountFormContainer,
  PasswordFormContainer,
  NotificationSettingsFormContainer,
  TimezoneFormContainer,
} from "@platform/features/account";

export function DashboardSettingsPage() {
  return (
    <>
      <AppPageHeader
        title="Settings"
        description="Update your account settings and preferences."
      />
      <OuterContentContainer className="flex flex-1" innerClassName="gap-8">
        <div className="w-full flex flex-col gap-6 pb-8 max-w-3xl">
          <SectionHeading
            title="Your Timezone"
            description="All dates and times are displayed in your selected timezone."
          >
            <TimezoneFormContainer label="Timezone" layout="horizontal" />
          </SectionHeading>
          <SectionHeading title="Your Account">
            <AccountFormContainer />
          </SectionHeading>
          <SectionHeading title="Change Password">
            <PasswordFormContainer />
          </SectionHeading>
          <SectionHeading title="Notification Settings">
            <NotificationSettingsFormContainer />
          </SectionHeading>
        </div>
      </OuterContentContainer>
    </>
  );
}

export default DashboardSettingsPage;
